import React from "react";
import { Row, Col } from "antd";
import { Route, Switch } from "react-router-dom";
import MenuTop from "../components/Web/MenuTop";
import Footer from "../components/Web/Footer";
import "./LayoutBasic.scss";

export default function LayoutBasic(props) {
  const { routes } = props; //puede colocarse al inicio de funcion LayoutBasic({routes})

  return (
    <>
      <Row>
        <Col md={4} />
        <Col md={16}>
          <MenuTop />
          {/*to do = resolucion para movil mostrar 1 componente, navegador otro componente
            ("La resolucion es:" + screen.width +screen.height)    ?  :                   */}
        </Col>
        <Col md={4} />
      </Row>
      <LoadRoutes routes={routes}></LoadRoutes>
      <Footer />
    </>
  );
}

function LoadRoutes({ routes }) {
  return (
    <Switch>
      {routes.map((routes, index) => (
        <Route
          key={index}
          path={routes.path}
          exact={routes.exact}
          component={routes.component}
        />
      ))}
    </Switch>
  );
}
